import React, { useState } from "react";
import AdminTopbar from "../../component/AdminTopbar";
import { Calendar, Filter, MessageCircle, Plus, Tag } from "react-feather";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const initialTasks = {
  "in-progress": [
    { id: "1", title: "Update Design", date: "Jun 6", label: "Update" },
    {
      id: "2",
      title: "Sync With Google Analytics",
      date: "Jun 12",
      label: "Daily",
      team: [
        { avatar: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0fpyFDyZREJAPrVNopvl8p6i5IvVIFSsKIA&s" },
        { avatar: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0fpyFDyZREJAPrVNopvl8p6i5IvVIFSsKIA&s" },
      ],
    },
  ],
  pending: [
    {
      id: "3",
      title: "Create Inventory Module",
      date: "Jun 23",
      label: "Create",
    },
    { id: "4", title: "Pay App Wages", date: "Aug 11", label: "Performance" },
  ],
  "in-review": [
    {
      id: "5",
      title: "Convert Figma To React",
      date: "Jun 20",
      label: "Create",
    },
    { id: "6", title: "Build UI For Search", date: "Jun 22", label: "Create" },
  ],
  done: [
    { id: "8", title: "Backup System", date: "Jul 8", label: "Daily" },
    { id: "9", title: "Tracking Bugs", date: "Jun 9", label: "Done" },
  ],
};

const columnTitles = {
  "in-progress": { title: "In Progress", color: "#60a5fa" },
  pending: { title: "Pending", color: "#facc15" },
  "in-review": { title: "In Review", color: "#a78bfa" },
  done: { title: "Done", color: "#22c55e" },
};

const AdminKanban = () => {
  const [tasks, setTasks] = useState(initialTasks);

  const [selectedColor, setSelectedColor] = useState("#000");

  const taskColors = [
    "#000",
    "#3b82f6",
    "#14b8a6",
    "#a855f7",
    "#f59e0b",
    "#ef4444"
  ];


  const [dueDate, setDueDate] = useState(null);

  return (
    <>
    
    
    
    
    <div className="App" style={{ display: "flex" }}>
      <div className="" style={{ flexGrow: 1, padding: "0px" }}>
        <AdminTopbar />

        <div className="kanban-container  px-4">
          <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
            <div>
              <h2 className="chart-title text-start">Kanban Board</h2>
              <p>List of your ongoing projects</p>
            </div>
            <div className="d-flex align-items-center">
             
            </div>
          </div>



<section className="kanbnms">


<div className=" kanban-row text-start py-3">


<div className="kanban-contain col">
<div class="card1">
  <img src="https://tailux.piniastudio.com/images/objects/object-11.jpg" alt="Update Design"/>
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
        <span><Tag size={14}/> 1</span>
        <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1">
 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
        <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1">
 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
        <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<button class="add-task" data-bs-toggle="modal" data-bs-target="#taskModal">+ Add New Task</button>
</div>






{/* colom 2 */}

<div className="kanban-contain">
<div class="card1">

  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1">
<img src="https://tailux.piniastudio.com/images/technology/testing-sm.jpg" alt="Update Design"/>
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>


<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>
<button class="add-task" data-bs-toggle="modal" data-bs-target="#taskModal">+ Add New Task</button>
 
</div>





{/* colom 3 */}

<div className="kanban-contain">
<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1">
  <img src="https://tailux.piniastudio.com/images/technology/hand-write-laptop.jpg" alt="Update Design"/>
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>


<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>

<button class="add-task" data-bs-toggle="modal" data-bs-target="#taskModal">+ Add New Task</button>
</div>


{/* colom 4 */}

<div className="kanban-contain">
<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>



<div class="card1"> 
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>


<div class="card1">
  <img src="https://tailux.piniastudio.com/images/technology/sales-presentation-sm.jpg" alt="Update Design"/>
  <div class="card-body">
    <h3 class="title">Update Design</h3>
    <div class="meta">
      <span class="date">
      <Calendar size={14}/> Jun 6
      </span>
      <span class="tag">Update</span>
    </div>
    <div class="footer">
      <div class="avatars">
        <img src="https://i.pravatar.cc/20?img=1" alt="user1"/>
        <img src="https://i.pravatar.cc/20?img=2" alt="user2"/>
        <img src="https://i.pravatar.cc/20?img=3" alt="user3"/>
      </div>
      <div class="icons">
      <span><Tag size={14}/> 1</span>
      <span><MessageCircle size={14}/> 3</span>
      </div>
    </div>
  </div>
</div>

<button class="add-task" data-bs-toggle="modal" data-bs-target="#taskModal">+ Add New Task</button>
</div>



{/* colom 5 */}

<div className="kanban-contain">
 
<button class="add-task" data-bs-toggle="" data-bs-target="#">+ Add New Column</button>
</div>

</div>




</section>



















































 
        </div>
      </div>
    </div>

    {/* modal start */}
    
    <div className="modal fade" id="taskModal" tabIndex="-1">
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content p-4">
          <div className="modal-header border-bottom pb-2 mb-3">
            <h5 className="modal-title">
              <i className="bi bi-info-circle me-2"></i> Task Title
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <div className="modal-body">
            {/* Labels & Members */}
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label text-start d-block">
                  Labels:
                </label>
                <select className="form-select">
                  <option>Not Selected Labels</option>
                  <option>Urgent</option>
                  <option>Low Priority</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label text-start d-block">
                  Members:
                </label>
                <select className="form-select">
                  <option>Unassigned</option>
                  <option>Alex</option>
                  <option>Jordan</option>
                </select>
              </div>
            </div>

            {/* Due Date & Task Color */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-6">
                <label className="form-label text-start d-block">
                  Due Date:
                </label>
                <div className="input-group">
                  
                  {/* <input type="date" className="form-control" /> */}
                  <DatePicker
                            id="dueDate"
                            selected={dueDate}
                            onChange={(date) => setDueDate(date)}
                            className="form-control w-100"
                            placeholderText="📅 Start date"
                            dateFormat="yyyy-MM-dd"
                          />
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label text-start d-block">
                  Task Color:
                </label>
                <div className="d-flex gap-2 pt-1">
                  {taskColors.map((color, idx) => (
                    <div
                      key={idx}
                      className={`rounded-circle border ${
                        selectedColor === color ? "border-3 border-dark" : ""
                      }`}
                      onClick={() => setSelectedColor(color)}
                      style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: color,
                        cursor: "pointer",
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label text-start d-block">
                <i className="bi bi-journal-text me-2"></i>Description:
              </label>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Task Description"
              ></textarea>
            </div>

            {/* File Upload */}
            <div className="mb-3">
              <label className="form-label text-start d-block">
                <i className="bi bi-paperclip me-2"></i>Attach files:
              </label>
              <input type="file" className="form-control" />
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer border-top pt-3 mt-3 d-flex justify-content-between">
            <button className="btn btn-outline-danger">
              <i className="bi bi-trash3 me-2"></i>Delete
            </button>
            <div>
              <button className="btn btn-light me-2" data-bs-dismiss="modal">
                Cancel
              </button>
              <button className="btn btn-primary">Update Task</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* modal end */}
    </>
  );
};

export default AdminKanban;
